/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * One or more ships used for selection in aisWeb.
 * @export
 * @interface SelectShip
 */
export interface SelectShip {
    /**
     * 
     * @type {string}
     * @memberof SelectShip
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof SelectShip
     */
    owner?: string;
    /**
     * 
     * @type {Array<Ship>}
     * @memberof SelectShip
     */
    ship?: Array<Ship>;
}

/**
 * Check if a given object implements the SelectShip interface.
 */
export function instanceOfSelectShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SelectShipFromJSON(json: any): SelectShip {
    return SelectShipFromJSONTyped(json, false);
}

export function SelectShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectShip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': !exists(json, 'username') ? undefined : json['username'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'ship': !exists(json, 'ship') ? undefined : ((json['ship'] as Array<any>).map(ShipFromJSON)),
    };
}

export function SelectShipToJSON(value?: SelectShip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'owner': value.owner,
        'ship': value.ship === undefined ? undefined : ((value.ship as Array<any>).map(ShipToJSON)),
    };
}

